/**
 * BookingContactForm - Contact support form when driver has accepted
 */
import React from 'react';
import { Button } from '../../ui/button';
import { MessageSquare, Phone, X, Loader2 } from 'lucide-react';

const BookingContactForm = ({
  show,
  onClose,
  contactMessage,
  setContactMessage,
  onSubmit,
  loading
}) => {
  if (!show) return null;

  return (
    <div className="bg-[#0B0B0B] border border-[#C9A24D]/30 rounded-lg p-3 sm:p-4">
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <h3 className="text-[#C9A24D] font-medium flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base">
          <MessageSquare className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
          Contacter le support
        </h3>
        <button 
          onClick={onClose}
          className="p-1.5 hover:bg-[#C9A24D]/10 rounded"
        >
          <X className="w-4 h-4 text-[#E5E5E5]/60" />
        </button>
      </div>
      <p className="text-[#E5E5E5]/60 text-[10px] sm:text-xs mb-2 sm:mb-3">
        Décrivez votre demande de modification ou d&apos;annulation. Notre équipe vous recontactera dans les plus brefs délais.
      </p>
      <textarea
        value={contactMessage}
        onChange={(e) => setContactMessage(e.target.value)}
        placeholder="Décrivez votre demande..."
        className="w-full h-20 sm:h-24 p-2.5 sm:p-3 bg-[#1F1F1F] border border-[#C9A24D]/30 rounded-lg text-[#E5E5E5] placeholder:text-[#E5E5E5]/40 text-xs sm:text-sm resize-none focus:border-[#C9A24D] focus:outline-none"
        data-testid="contact-message-textarea"
      />
      <div className="flex items-center gap-2 mt-2 sm:mt-3">
        <Button
          onClick={onSubmit}
          disabled={loading || !contactMessage.trim()}
          className="flex-1 bg-[#C9A24D] hover:bg-[#B8933C] text-black font-medium text-xs sm:text-sm h-9 sm:h-10"
          data-testid="send-contact-btn"
        >
          {loading ? (
            <><Loader2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2 animate-spin" /> <span className="hidden sm:inline">Envoi...</span></>
          ) : (
            <><MessageSquare className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" /> <span className="hidden sm:inline">Envoyer la demande</span><span className="sm:hidden">Envoyer</span></>
          )}
        </Button>
        <a 
          href="tel:+33278780404" 
          className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md text-xs sm:text-sm font-medium h-9 sm:h-10"
        >
          <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
          <span className="hidden sm:inline">Appeler</span>
        </a>
      </div>
    </div>
  );
};

export default BookingContactForm;
